// extracted by mini-css-extract-plugin
export default {"produceaisle":"ecf4f8aec16e11b5f30a","name":"bf557259c941112bc597"};